<template>
    <div class="fileDropAreaSignatureTopaz">
         

         <div class="row">
                <div class="col-md-12">
                    <div class="s-header" v-bind:style="styletitle">
                        <span class="s-title">{{ this.Title }}</span>
                        <div
                            class="btn-group btn-group-sm float-sm-right"
                            role="group"
                            aria-label="Signature options"
                        >
                            <b-button size="sm" @click="Clear" class="table-title-btn">{{
                                $t('MdEditTableCN.Clear')
                            }}</b-button>
                            <b-button size="sm" v-on:click="Undo" class="table-title-btn">{{
                                $t('Shared.Undo')
                            }}</b-button>
                        </div>
                    </div>
                    <canvas
                        :id="idLocal"
                        width="513"
                        class="signature"
                        v-on:mousedown="handleMouseDown"
                        v-on:mouseup="handleMouseUp"
                        v-on:mousemove="handleMouseMove"
                        v-on:mouseout="handleMouseOut"
                        v-on:touchstart="touchstart"
                        v-on:touchend="touchend"
                        v-on:touchmove="touchmove"
                    >
                    </canvas>
                </div>
            </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import SigWebFunc from '@/components/MedEZComponents/signature/SigWebFunc.js';
import { EventBus } from '@/event-bus.js';
export default {
    props: {
        Title: String,
        Id: String,
        LinkId: String,
        Data64: String,
        TopazSignatureVisible: Boolean,
        RefSignatureId:String,
        VisibleLoadImage: Boolean,
        OnlyData: {
            type: Boolean,
            default: true
        }
    },
    mixins: [ShowMessage],
    data: function() {
        return {

            files: [],
            dataUrl: '',
            CanNotDraw: false,
            CanvasToBMP_dly: 9,
            drawing: false,
            mouse: { x: 0, y: 0 },
            previous: { x: 0, y: 0 },
            points: [],
            pathsry: [],
            base64Value: this.Data64,
            ReadOnly: false,
            titleLocal: this.Title,
            idLocal: this.Id,
            stylecanvas: { backgroundColor: '#FFF' },
            ChartReview: this.IsChartReview,
            styletitle: {
                position: 'absolute',
                width: 513 + 'px'
            },
            topaz_flag: false
        };
    },
    watch: {
        Data64(newValue) {
            if (this.base64Value !== newValue) {
                this.base64Value = newValue;
                const currentImage = this.dataUrl ? this.dataUrl.split(',')[1] : '';

                if (currentImage !== newValue) {
                    this.dataUrl = 'data:image/bmp;base64,' + newValue;
                    this.canvasImage(this.dataUrl);
                }
            }
        }
    },
    methods: {

        Undo() {
            this.pathsry.splice(-1, 1);
            this.drawPaths();
        },

        checkSigWeb() {
            var response = SigWebFunc.startTablet(this.idLocal);

            if (response.type != 'error') {
                this.topaz_flag = true;
            } else {
                this.showMessage(this.$tc('Msg.Error'), response.message, response.type);
            }
        },

        drawPaths: function() {
            var canvas = document.getElementById(this.idLocal);
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.pathsry.forEach(path => {
                ctx.beginPath();
                ctx.moveTo(path[0].x, path[0].y);
                for (let i = 1; i < path.length; i++) {
                    ctx.lineTo(path[i].x, path[i].y);
                }
                ctx.stroke();
            });
        },

        SyncFileReader(file) {
            let self = this;
            let ready = false;
            let result = '';

            const sleep = function(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            };

            self.readAsDataURL = async function() {
                while (ready === false) {
                    await sleep(100);
                }
                return result;
            };

            const reader = new FileReader();
            reader.onloadend = function(evt) {
                result = evt.target.result;
                ready = true;
            };
            reader.readAsDataURL(file);
        },

        CleanComponent() {
            this.files = [];
            this.Clear();
            this.$refs.input.value = '';
        },

        handleMouseDown: function(event) {
            var canvas = document.getElementById(this.idLocal);
            event.preventDefault();
            this.drawing = true;
            this.previous = { x: this.mouse.x, y: this.mouse.y };
            this.mouse = this.oMousePos(canvas, event);
            this.points = [];
            this.points.push({ x: this.mouse.x, y: this.mouse.y });
        },

        oMousePos(canvas, evt) {
            var ClientRect = canvas.getBoundingClientRect();
            return {
                x: Math.round(evt.clientX - ClientRect.left),
                y: Math.round(evt.clientY - ClientRect.top)
            };
        },

        handleMouseOut: function(event) {
            this.drawing = false;
            EventBus.$emit(
                'onMouseStop',
                this.OnlyData ? this.dataUrl : { Id: this.Id, Image: this.dataUrl }
            );
            event.preventDefault();
        },

        touchmove: function(event) {
            var canvas = document.getElementById(this.idLocal);
            event.preventDefault();
            var touch = event.touches[0];
            var mouseEvent = new MouseEvent('mousemove', {
                clientX: touch.clientX,
                clientY: touch.clientY
            });
            canvas.dispatchEvent(mouseEvent);
        },

        touchend: function(event) {
            var canvas = document.getElementById(this.idLocal);
            //canvas.style = "";
            event.preventDefault();
            var mouseEvent = new MouseEvent('mouseup', {});
            canvas.dispatchEvent(mouseEvent);
        },

        touchstart: function(event) {
            var canvas = document.getElementById(this.idLocal);
            //canvas.style = "";
            //mousePos = getTouchPos(canvas, event);
            event.preventDefault();
            var touch = event.touches[0];
            var mouseEvent = new MouseEvent('mousedown', {
                clientX: touch.clientX,
                clientY: touch.clientY
            });

            canvas.dispatchEvent(mouseEvent);
        },

        handleMouseUp: function(event) {
            this.drawing = false;
            this.pathsry.push(this.points);
            this.Save();
            event.preventDefault();
        },

        Save() {
            var canvas = document.getElementById(this.idLocal);
            this.dataUrl = canvas.toDataURL();
            EventBus.$emit(
                'onMouseStop',
                this.OnlyData ? this.dataUrl : { Id: this.Id, Image: this.dataUrl }
            );
        },

        SaveTopaz() {
            if(this.topaz_flag == true){
                SigWebFunc.onDone(this.SigImageCallback);
            }
        },

        SigImageCallback( str )
        {
            EventBus.$emit("OnTopazConfirm", this.LinkId, str);
        },

        handleMouseMove: function(event) {
            var canvas = document.getElementById(this.idLocal);
            var ctx = canvas.getContext('2d');
            event.preventDefault();
            if (!this.drawing) return;

            ctx.lineWidth = 3;
            this.previous = { x: this.mouse.x, y: this.mouse.y };
            this.mouse = this.oMousePos(canvas, event);
            this.points.push({ x: this.mouse.x, y: this.mouse.y });
            ctx.beginPath();
            ctx.moveTo(this.previous.x, this.previous.y);
            ctx.lineTo(this.mouse.x, this.mouse.y);
            ctx.stroke();
        },

        canvasImage: function(base64) {
            var x = document.getElementById(this.idLocal);
            var canvas = x.getContext('2d');
            var image = new Image();
            image.src = base64;
            image.addEventListener(
                'load',
                function() {
                    canvas.drawImage(image, 0, 0);
                },
                false
            );
        },

        Clear() {
            if(this.topaz_flag == true){
                SigWebFunc.onClear()
            }
            var canvas = document.getElementById(this.idLocal);
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            var w = canvas.width;
            canvas.width = 1;
            canvas.width = w;
            this.dataUrl = '';
            EventBus.$emit(
                'onMouseStop',
                this.OnlyData ? this.dataUrl : { Id: this.Id, Image: this.dataUrl }
            );
        },

    },

    created() {
        EventBus.$on(
            'onGetImage',
            function(image) {
                if (image) {
                    this.dataUrl = 'data:image/bmp;base64,' + image;
                    this.canvasImage(this.dataUrl);
                }
            }.bind(this)
        );
    },

    mounted() {
        if (this.Data64) {
            this.dataUrl = 'data:image/bmp;base64,' + this.Data64;
            this.canvasImage(this.dataUrl);
        }

        this.checkSigWeb();
    }
};
</script>

<style>
.ng-invalid {
    border: 1px solid red !important;
}

.AutoHeightContainerMoreFiles {
    height: calc(100% + 250px) !important;
}

.AutoHeightContainerMinusFiles {
    height: 550px !important;
}

.fileDropArea {
    height: calc(100vh - 224px) !important;
}
</style>
